import { render, staticRenderFns } from "./quiz_bulk_approval.vue?vue&type=template&id=7dc09081&scoped=true&"
import script from "./quiz_bulk_approval.vue?vue&type=script&lang=js&"
export * from "./quiz_bulk_approval.vue?vue&type=script&lang=js&"
import style0 from "./quiz_bulk_approval.vue?vue&type=style&index=0&id=7dc09081&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc09081",
  null
  
)

export default component.exports